import { createApi } from '@reduxjs/toolkit/query/react'

import { PROXY_API_V1_URL, ontologyBaseQuery } from '../core'
import type {
  BugReport,
  BugReportListResponse,
  CreateBugReportPayload,
  ListBugReportsArgs,
  UpdateBugReportPayload
} from './types'

export const feedbackApi = createApi({
  reducerPath: 'feedbackApi',
  baseQuery: ontologyBaseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  tagTypes: ['BugReport'],
  endpoints: (builder) => ({
    createBugReport: builder.mutation<BugReport, CreateBugReportPayload>({
      query: (body) => ({
        url: `${PROXY_API_V1_URL}/feedback`,
        method: 'POST',
        body
      }),
      invalidatesTags: [{ type: 'BugReport', id: 'LIST' }]
    }),
    updateBugReport: builder.mutation<BugReport, UpdateBugReportPayload>({
      query: ({ id, ...body }) => ({
        url: `${PROXY_API_V1_URL}/feedback/${encodeURIComponent(id)}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'BugReport', id },
        { type: 'BugReport', id: 'LIST' }
      ]
    }),
    listBugReports: builder.query<BugReportListResponse, ListBugReportsArgs | void>({
      query: (args) => ({
        url: `${PROXY_API_V1_URL}/feedback`,
        params: {
          limit: args?.limit ?? 50,
          page_token: args?.pageToken,
          status: args?.status,
          flagged: args?.flagged
        }
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.bug_reports.map((report) => ({
                type: 'BugReport' as const,
                id: report.id
              })),
              { type: 'BugReport' as const, id: 'LIST' }
            ]
          : [{ type: 'BugReport' as const, id: 'LIST' }]
    })
  })
})

export const { useCreateBugReportMutation, useUpdateBugReportMutation, useListBugReportsQuery } =
  feedbackApi
